import React from 'react';

const LabelIcon = (props) => {

    if (props.type === "system") {
	    return (
		    <svg
			    className="mr-2"
			    xmlns="http://www.w3.org/2000/svg"
			    width={24}
			    height={24}
			    viewBox="0 0 24 24"
			    xmlSpace="preserve"
			    {...props}
		    >
			    <circle
				    fill="#f5f5f5"
				    cx={12}
				    cy={12}
				    r={12}
				    style={{
					    strokeWidth: 0.727,
				    }}
			    />
			    <path
				    fill="#4285f4"
				    d="M20.911 12.209a10.6 10.6 0 0 0-.157-1.848H12.18v3.501h4.91a4.2 4.2 0 0 1-1.817 2.763v2.271h2.929c1.721-1.583 2.709-3.921 2.709-6.687"
				    style={{
					    strokeWidth: 0.727,
				    }}
			    />
			    <path
				    fill="#34a853"
				    d="M12.18 21.091c2.452 0 4.52-.804 6.026-2.196l-2.929-2.271c-.815.555-1.867.869-3.093.869-2.372 0-4.383-1.601-5.105-3.751H4.056v2.341a9.09 9.09 0 0 0 8.124 5.008"
				    style={{
					    strokeWidth: 0.727,
				    }}
			    />
			    <path
				    fill="#fbbc04"
				    d="M7.076 13.743a5.44 5.44 0 0 1 0-3.481V7.92h-3.02a9.1 9.1 0 0 0 0 8.164z"
				    style={{
					    strokeWidth: 0.727,
				    }}
			    />
			    <path
				    fill="#ea4335"
				    d="M12.18 6.506a4.95 4.95 0 0 1 3.487 1.364l2.596-2.596a8.73 8.73 0 0 0-6.084-2.364 9.09 9.09 0 0 0-8.123 5.01l3.02 2.342c.717-2.155 2.732-3.756 5.104-3.756"
				    style={{
					    strokeWidth: 0.727,
				    }}
			    />
		    </svg>
	    )
    } else if (props.type === "directory") {
	    return (
		    <svg width="20" height="20" viewBox="0 0 24 24" className="mr-1">
			    <path fill="none" d="M0 0h24v24H0V0z"/>
			    <path
				    d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
		    </svg>
	    )
    } else if (props.type === "recent") {
    	return <svg
		    width="20"
		    height="20"
		    xmlns="http://www.w3.org/2000/svg"
		    viewBox="0 0 24 24"
		    style={{margin: '0 12px 0 2px'}}
	    >
		    <path d="m15.96 17.64 1.68-1.68-4.44-4.44V6h-2.4v6.48zM12 24q-2.49 0-4.68-.945T3.51 20.49.945 16.68 0 12t.945-4.68T3.51 3.51 7.32.945 12 0t4.68.945 3.81 2.565 2.565 3.81T24 12t-.945 4.68-2.565 3.81-3.81 2.565T12 24m0-2.4q3.99 0 6.795-2.805T21.6 12t-2.805-6.795T12 2.4 5.205 5.205 2.4 12t2.805 6.795T12 21.6" />
	    </svg>
    } else {
        switch (props.status) {
            case 'NOT_SHARED' :
                return (
                    <svg width="20" height="20" viewBox="0 0 24 24" className="mr-1 align-middle">
                        <path fill="none" d="M0 0h24v24H0V0z"/>
                        <path
                            d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"/>
                    </svg>
                );
            case 'SHARED' :
                return (
                    <svg width="20" height="20" viewBox="0 0 20 20" className="mr-1">
                        <path fill="none" d="M0,0v20h20V0H0z M14.699,15.2c-0.299,0.4-0.799,0.7-1.4,0.7H4.1c-0.9,0-1.7-0.7-1.7-1.7V5.9
									c0-0.9,0.8-1.7,1.7-1.7h9.199c0.602,0,1.102,0.3,1.4,0.7l3.6,5.1L14.699,15.2z"/>
                        <path d="M13.299,4.2H4.1c-0.9,0-1.7,0.7-1.7,1.7v8.3c0,0.9,0.8,1.7,1.7,1.7h9.199c0.602,0,1.102-0.3,1.4-0.7l3.6-5.1L14.699,5
									C14.4,4.5,13.9,4.2,13.299,4.2z M8.9,6c1.101,0,2,0.9,2,2c0,1.101-0.9,2-2,2c-1.1,0-2-0.899-2-2C6.9,6.9,7.8,6,8.9,6z M12.9,14h-8
									v-1c0-1.3,2.7-2,4-2c1.3,0,4,0.7,4,2V14z"/>
                    </svg>
                );
            case 'SHARED_WITH_ME' :
                return (
                    <svg width="20" height="20" viewBox="0 0 20 20" className="mr-1">
                        <path d="M8.6,6.5c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7C6.8,7.2,7.6,6.5,8.6,6.5z
		 							M12,13.3H5.1v-0.9c0-1.1,2.3-1.7,3.4-1.7s3.4,0.6,3.4,1.7V13.3z"/>
                        <path d="M14.3,4.9c-0.3-0.4-0.8-0.7-1.4-0.7H3.7c-0.9,0-1.7,0.8-1.7,1.7v8.3c0,0.9,0.8,1.7,1.7,1.7h9.2
									c0.6,0,1.1-0.3,1.4-0.7l3.6-5.1L14.3,4.9z M12.9,14.2H3.7V5.8h9.2l3,4.2L12.9,14.2z"/>
                    </svg>
                );
            default :
                return (
                    <svg width="20" height="20" viewBox="0 0 24 24" className="mr-1 align-middle">
                        <path fill="none" d="M0 0h24v24H0V0z"/>
                        <path
                            d="M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"/>
                    </svg>
                )
        }
    }

};

export default LabelIcon;
